import { PplxError } from '#pplx/frontend/common/errors.js';
export class ApiClientsError extends PplxError {
    name = 'ApiClientsError';
    status;
    detail;
    constructor(code, args) {
        super(code, {
            message: args.message,
            cause: args.cause,
            details: { ...args.details, status: args.status },
        });
        this.status = args.status;
        if (args.cause &&
            typeof args.cause === 'object' &&
            'detail' in args.cause &&
            args.cause.detail &&
            typeof args.cause.detail === 'object') {
            this.detail = args.cause.detail;
        }
    }
}
//# sourceMappingURL=errors.js.map